import { useExportListWinners } from 'src/app/modules/campaign/providers/LuckyDraw.provider'
import { useParams } from 'react-router-dom'
import {
  useListWinnersConsolation,
  useListWinnersGrandprize,
} from '../../../providers/LuckyDraw.provider'

export function useLuckyDrawDetailTabWinners() {
  const params = useParams<{id: string}>()

  const grandPrizeList = useListWinnersGrandprize(params.id)
  const exportWinners = useExportListWinners(params.id)
  const consolationList = useListWinnersConsolation(params.id)

  return {
    grandPrizeList,
    consolationList,
    exportWinners,
  }
}
